import { Link } from 'react-router-dom';
import { trendingComics } from '@/mocks/comics';

export default function DailyUpdates() {
  const leftComic = trendingComics[0];

  return (
    <section className="w-full flex flex-col lg:flex-row">
      <div className="lg:w-1/2 relative min-h-[350px] md:min-h-[480px] overflow-hidden bg-secondary-100">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20atmosphere%2C%20warm%20cozy%20indoor%20scene%2C%20soft%20natural%20light%20through%20window%2C%20comfortable%20reading%20nook%20with%20plants%2C%20gentle%20cream%20and%20beige%20tones%2C%20peaceful%20aesthetic%2C%20minimal%20composition%2C%20relaxing%20vibe&width=1200&height=900&seq=daily-update-left&orientation=portrait"
          alt="每日更新 - 韩国漫画"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        <div className="absolute top-6 left-6 md:top-8 md:left-8">
          <span className="text-xs md:text-sm text-white/70 font-label tracking-wider">
            每日更新
          </span>
        </div>
        <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10">
          <Link to={`/comic/${leftComic.id}`} className="cursor-pointer">
            <p className="text-xl md:text-3xl lg:text-4xl font-heading font-black text-white leading-tight max-w-sm">
              {leftComic.title}
            </p>
            <p className="text-sm md:text-base text-white/60 mt-2 font-label">
              {leftComic.author} · 更新至 {leftComic.chapters} 话
            </p>
          </Link>
        </div>
      </div>

      <div className="lg:w-1/2 flex flex-col items-center justify-center py-12 md:py-16 px-6 md:px-12 lg:px-16 bg-background-100">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center leading-tight mb-4">
          每日上新
          <br />
          追更不停
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center max-w-md mb-8 leading-relaxed">
          每日精选最新更新的韩漫佳作，让你永远不会错过任何精彩剧情。
          热门连载同步更新，第一时间体验最新话。
        </p>

        <div className="w-full max-w-md space-y-4">
          {trendingComics.slice(0, 5).map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-3 rounded-xl hover:bg-background-200/60 transition-colors cursor-pointer group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl overflow-hidden flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm md:text-base font-label font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {comic.title}
                </h4>
                <p className="text-xs text-foreground-500 mt-0.5">
                  {comic.author} · {comic.categories[0]}
                </p>
              </div>
              <div className="flex items-center gap-1 text-xs text-accent-600 font-label whitespace-nowrap">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                更新至{comic.chapters}话
              </div>
            </Link>
          ))}
        </div>

        <Link
          to="/latest"
          className="mt-8 px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-label font-semibold cursor-pointer hover:bg-primary-600 transition-colors whitespace-nowrap inline-flex items-center gap-2"
        >
          查看更多更新
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}